import styled from "styled-components";
import { Text } from "../Text";

export const StyledBottomNavItem = styled.button`
  display: block;
  border: 0;
  background: transparent;
  cursor: pointer;
  height: 44px;
  /* 8 px sides (was 12): "Compete" (12 px) fits its fifth of a 360 px bar with room to spare */
  padding: 4px 8px;
  &:hover {
    border-radius: 16px;
  }
  &:hover,
  &:hover div {
    background: ${({ theme }) => theme.colors.tertiary};
  }
`;

export const StyledBottomNavText = styled(Text)`
  display: -webkit-box;
  overflow: hidden;
  user-select: none;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
`;

/** The featured destination (Swap): a raised round button in the primary colour, the label under it like the other tabs. */
export const FeaturedDisc = styled.span<{ $active: boolean }>`
  display: grid;
  place-items: center;
  flex: none; /* the 44px item would otherwise squash the disc into an oval */
  width: 44px;
  height: 44px;
  /* raised: most of the disc sits above the bar so the label keeps the same line as the other tabs (36px inner height) */
  margin-top: -26px;
  margin-bottom: 2px;
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.invertedContrast};
  background: ${({ theme }) => theme.colors.primary};
  box-shadow: 0 0 0 4px ${({ theme }) => theme.colors.backgroundAlt},
    0 8px 18px -6px ${({ theme }) => theme.colors.primary};
  outline: ${({ $active, theme }) => ($active ? `2px solid ${theme.colors.primary}` : "none")};
  outline-offset: 5px;
  svg {
    fill: currentColor;
  }
`;

/** A tab with a live slot (Compete): the tab link and the live logos' link side by side, the logos laid over the icon box. */
export const LiveItem = styled.span`
  position: relative;
  display: block;
`;
